import styled, { css } from "styled-components";

// styles
import colors from "core/colors";
import { convertPxToRem } from "frontend/components/helpers";
import { dialogDropShadow } from "core/boxShadows.js";

// components
import { Image as CaretDownIcon } from "core/ReusableIcons/CaretDown";
import { Image as EditIcon } from "core/ReusableIcons/Edit";
import { Image as CheckmarkIcon } from "core/ReusableIcons/Checkmark";

// styled-components
export const FormSelectDialogStyled = styled.div`
    position: relative;
    width: ${({ controlWidth }) => controlWidth};
`;

/*---------------------------
| Control Button
---------------------------*/
export const ButtonStyled = styled.button`
    display: flex;
    align-items: center;

    width: 100%;
    height: ${({ controlHeight }) => convertPxToRem({ px: controlHeight })};
    padding: 0px;
    border: none;
    border-radius: 0px;
    background-color: transparent;
    font-size: ${convertPxToRem({ px: 15 })};
    cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};
`;

export const DisplayTextStyled = styled.div`
    flex: 0 0 auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-right: ${convertPxToRem({ px: 8 })};
`;
export const IconStyled = styled.div`
    flex: 0 0 16px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

/*---------------------------
| Control Styles Outer Container
---------------------------*/
const ControlStyles = css`
    width: 100%;
`;

export const ControlCaretStyled = styled.div`
    ${ControlStyles}
    position: relative;

    ${ButtonStyled} {
        background-color: white;
        padding: ${convertPxToRem({ px: 1 })} ${convertPxToRem({ px: 12 })};
        border: 3px solid ${colors.primary.diamond};

        &:hover,
        &:focus,
        &:active {
            background-color: ${colors.primary.diamond};
        }

        ${CaretDownIcon} {
            position: absolute;
            right: ${convertPxToRem({ px: 10 })};
            top: 50%;
            transform: translate(0, -50%);

            ${({ isOpen }) => {
                if (isOpen) {
                    return css`
                        transform: translate(0, -50%) rotate(180deg);
                    `;
                }
            }}
        }
    }
`;
export const ControlEditStyled = styled.div`
    ${ControlStyles}
    ${ButtonStyled} {
        ${EditIcon} {
            path {
                fill: ${colors.accent.lightMode.persian};
            }
        }
    }
`;

/*---------------------------
| Dialog
---------------------------*/
export const DialogStyled = styled.div`
    border: 1px solid ${colors.primary.diamond};
    background-color: white;
    width: ${({ dialogWidth }) => dialogWidth};
    box-shadow: ${dialogDropShadow};

    position: absolute;
    top: ${({ controlHeight }) =>
        convertPxToRem({ px: controlHeight + 5 })}; //a little cushion
    z-index: ${({ dialogZIndex }) => dialogZIndex};

    ${({ dialogAlignment }) => {
        if (dialogAlignment === "left") {
            return css`
                left: 0px;
            `;
        }
        if (dialogAlignment === "center") {
            return css`
                left: 50%;
                transform: translate(-50%, 0);
            `;
        }
        if (dialogAlignment === "right") {
            return css`
                right: 0px;
            `;
        }
    }}
`;

export const DialogOptionStyled = styled.button`
    display: block;
    cursor: pointer;

    width: 100%;

    border: none;
    border-radius: 0px;
    background-color: transparent;

    padding: 0px;

    display: grid;
    gap: 0px;
    grid-template-columns: 35px auto;

    &:hover {
        background-color: ${colors.primary.moon};
    }

    ${CheckmarkIcon} {
        path {
            fill: ${colors.secondary.oolong};
        }
    }
`;

export const CheckMarkWrapperStyled = styled.div`
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;
export const DialogOptionTextStyled = styled.div`
    text-align: left;
    font-size: ${convertPxToRem({ px: 16 })};
    line-height: ${convertPxToRem({ px: 48 })};
`;
